{
  "messages": {
    "processing": "Traitement du fichier...",
    "dragHere": "Glissez votre SVG ici."
  }
}
